module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _keys = __webpack_require__(2), _keys2 = _interopRequireDefault(_keys), _assign = __webpack_require__(3), _assign2 = _interopRequireDefault(_assign), req = __webpack_require__(4);
    exports.default = req.keys().reduce(function(prev, file) {
        var vars = req(file);
        return (0, _assign2.default)(prev, vars), (0, _keys2.default)(vars).forEach(function(varName) {
            module.exports[varName] = vars[varName];
        }), prev;
    }, {});
}, /* 2 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/keys");
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/assign");
}, /* 4 */
/***/
function(module, exports, __webpack_require__) {
    function webpackContext(req) {
        return __webpack_require__(webpackContextResolve(req));
    }
    function webpackContextResolve(req) {
        return map[req] || function() {
            throw new Error("Cannot find module '" + req + "'.");
        }();
    }
    var map = {
        "./borders.less": 5,
        "./colors.less": 6,
        "./fonts.less": 7,
        "./grid.less": 8,
        "./z-indexes.less": 9
    };
    webpackContext.keys = function() {
        return Object.keys(map);
    }, webpackContext.resolve = webpackContextResolve, module.exports = webpackContext, 
    webpackContext.id = 4;
}, /* 5 */
/***/
function(module, exports) {
    module.exports = {
        akBorderRadius: "3px"
    };
}, /* 6 */
/***/
function(module, exports) {
    module.exports = {
        akColorPrimary1: "#172B4D",
        akColorPrimary2: "#0049B0",
        akColorPrimary3: "#FFFFFF",
        akColorSecondary1: "#FF5630",
        akColorSecondary2: "#FFAB00",
        akColorSecondary3: "#36B37E",
        akColorSecondary4: "#6554C0",
        akColorSecondary5: "#00B8D9",
        akColorR50: "#FFEBE6",
        akColorR75: "#FFBDAD",
        akColorR100: "#FF8F73",
        akColorR200: "#FF7452",
        akColorR300: "#FF5630",
        akColorR400: "#DE350B",
        akColorR500: "#BF2600",
        akColorY50: "#FFFAE6",
        akColorY75: "#FFF0B3",
        akColorY100: "#FFE380",
        akColorY200: "#FFC400",
        akColorY300: "#FFAB00",
        akColorY400: "#FF991F",
        akColorY500: "#FF8B00",
        akColorG50: "#E3FCEF",
        akColorG75: "#ABF5D1",
        akColorG100: "#79F2C0",
        akColorG200: "#57D9A3",
        akColorG300: "#36B37E",
        akColorG400: "#00875A",
        akColorG500: "#006644",
        akColorB50: "#DEEBFF",
        akColorB75: "#B3D4FF",
        akColorB100: "#4C9AFF",
        akColorB200: "#2684FF",
        akColorB300: "#0065FF",
        akColorB400: "#0052CC",
        akColorB500: "#0049B0",
        akColorP50: "#EAE6FF",
        akColorP75: "#C0B6F2",
        akColorP100: "#998DD9",
        akColorP200: "#8777D9",
        akColorP300: "#6554C0",
        akColorP400: "#5243AA",
        akColorP500: "#403294",
        akColorT50: "#E6FCFF",
        akColorT75: "#B3F5FF",
        akColorT100: "#79E2F2",
        akColorT200: "#00C7E6",
        akColorT300: "#00B8D9",
        akColorT400: "#00A3BF",
        akColorT500: "#008DA6",
        akColorN0: "#FFFFFF",
        akColorN10: "#FAFBFC",
        akColorN20: "#F4F5F7",
        akColorN30: "#EBECF0",
        akColorN40: "#DFE1E6",
        akColorN50: "#C1C7D0",
        akColorN60: "#B3BAC5",
        akColorN70: "#A5ADBA",
        akColorN80: "#97A0AF",
        akColorN90: "#8993A4",
        akColorN100: "#7A869A",
        akColorN200: "#6C798F",
        akColorN300: "#5E6C84",
        akColorN400: "#505F79",
        akColorN500: "#42526E",
        akColorN600: "#344563",
        akColorN700: "#253858",
        akColorN800: "#172B4D",
        akColorN900: "#091E42",
        akColorN10A: "rgba(9, 30, 66, 0.02)",
        akColorN20A: "rgba(9, 30, 66, 0.04)",
        akColorN30A: "rgba(9, 30, 66, 0.08)",
        akColorN40A: "rgba(9, 30, 66, 0.13)",
        akColorN50A: "rgba(9, 30, 66, 0.25)",
        akColorN60A: "rgba(9, 30, 66, 0.31)",
        akColorN70A: "rgba(9, 30, 66, 0.36)",
        akColorN80A: "rgba(9, 30, 66, 0.42)",
        akColorN90A: "rgba(9, 30, 66, 0.48)",
        akColorN100A: "rgba(9, 30, 66, 0.54)",
        akColorN200A: "rgba(9, 30, 66, 0.60)",
        akColorN300A: "rgba(9, 30, 66, 0.65)",
        akColorN400A: "rgba(9, 30, 66, 0.71)",
        akColorN500A: "rgba(9, 30, 66, 0.77)",
        akColorN600A: "rgba(9, 30, 66, 0.82)",
        akColorN700A: "rgba(9, 30, 66, 0.89)",
        akColorN800A: "rgba(9, 30, 66, 0.95)"
    };
}, /* 7 */
/***/
function(module, exports) {
    module.exports = {
        akFontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
        akFontSizeDefault: "14px",
        akCodeFontFamily: '"SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Courier, monospace'
    };
}, /* 8 */
/***/
function(module, exports) {
    module.exports = {
        akGridSize: "8px"
    };
}, /* 9 */
/***/
function(module, exports) {
    module.exports = {
        akZIndexLayer: "400",
        akZIndexBlanket: "500"
    };
} ]);


//////////////////
// WEBPACK FOOTER
// ./~/akutil-shared-styles/dist/bundle-cjs.js
// module id = 250
// module chunks = 0